import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { openManageItemsInCollectionsDialogAction } from '../../../actions/spaces/Collections/ManageItemsInCollectionAction';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';
import { MAX_ITEMS_PER_COLLECTION } from '../../Collections/ManageItemsInCollectionsDialog';

export const OpenManageItemsInCollectionsDialogEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.AddToCollections,
  translateName: Messages.addToCollections,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.collectionsEnabled && targetItems.length > 0 && !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[]) => {
    return targetItems.length <= MAX_ITEMS_PER_COLLECTION;
  },
  createReduxAction: (targetItems: IContentInfo[]) => openManageItemsInCollectionsDialogAction(targetItems)
};
